import React, { Component, Fragment } from "react";
import Navbar from "../../Components/ProducaoEP/Realizado/UI/Navbar";
import Agregador from "../../Components/ProducaoEP/Realizado/Relatorio2/Agregador";
import Switcher from "../../Components/ProducaoEP/Realizado/Relatorio2/Switcher";
import Select from "../../Components/ProducaoEP/Realizado/Relatorio1/Select";
import NomeUnidade from "../../Components/UI/NomeUnidade";
import MenuRelatorioEP from "./menuRelatorioEP";

export default class PageRelatorio2 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório",
            colunas: this.colunasDisponiveis(),
            colunasSelecionadas: []
        }
    }

    componentDidMount() {
        this.setState({ colunasSelecionadas: this.colunasUseMemo() })
    }

    onChange = (event) => {
        let novasColunas = { ...this.state.colunas };
        novasColunas[event.target.id] = !novasColunas[event.target.id];
        let colunasSelecionadas = this.colunasUseMemo(novasColunas);
        this.setState({ colunas: novasColunas, colunasSelecionadas });
    }

    colunasDisponiveis = () => {
        let colunas = {
            ARTICULA_SESI_SENAI: false,
            CATEGORIA: false,
            CBO: false,
            CD_ALUNO: false,
            CD_CURSO: false,
            CD_MATRICULA: false,
            CH_CURSO_EAD: false,
            CH_CURSO_FASE_ESTAGIO: false,
            CH_CURSO_PRESENCIAL: false,
            CONDICAO_ALUNO: false,
            DS_CURSO: false,
            DT_ENTRADA: false,
            DT_INICIO_OFERTA_CURSO: false,
            DT_NASC_ALUNO: false,
            DT_SAIDA: false,
            DT_SAIDA_PREVISTA: false,
            ESCOLA_ORIGEM: false,
            HORA_ALUNO: false,
            HORA_ALUNO_EAD: false,
            MES_REFERENCIA: true,
            MODALIDADE: true,
            MUNICIPIO_ACAO: false,
            MUNICIPIO_ENDERECO_ALUNO: false,
            NOME_ALUNO: false,
            SITUACAO_MATRICULA: true,
            TIPO_ACAO: false,
            TIPO_AMBIENTE: false,
            TIPO_ENTRADA_ALUNO: false,
            TIPO_FINANCIAMENTO: true,
            TIPO_MATRICULA: false,
            UF_ENDERECO_ALUNO: false,
            UNIDADE_ATENDIMENTO: true
        }
        return colunas;
    }

    colunasUseMemo = (colunas) => {

        if(!colunas) {
            colunas = this.state.colunas
        }
        
        let columns = []
        let tipoAgregadoSoma = ['HORA_ALUNO', 'HORA_ALUNO_EAD'];

        Object.keys(colunas).map((col, i) => {
            if(colunas[col]) {
                columns.push({
                    Header: col.replaceAll("_", " "),
                    accessor: col,
                    //aggregate: tipoAgregadoSoma.includes(col) ? 'sum' : 'count',
                    aggregate: tipoAgregadoSoma.includes(col) ? this.somaTotalHora : 'count',
                    Aggregated: ({ value }) => `${value}`,
                    
                })
            }
        })

        //this.setState({ colunasSelecionadas: columns });
        return columns

    }

    somaTotalHora = (leafValues, aggregatedValues) => {
        let somaTotal = aggregatedValues.reduce((acc, atual) => acc + Number(atual), 0);
        return somaTotal;
    }

    render() {
        let { colunas, colunasSelecionadas, url } = this.state;
        return(
            <Fragment>

                {/*
                <div className="row mb-4">
                    <Navbar />
                </div>
                */}

                <div className="container mt-4">

                    

                </div>

                <NomeUnidade unidade={"Relatórios"} />

                <div className="content">
                    <MenuRelatorioEP />
                    <div className="row">
                        <div className="col-md-12">
                            
                            <div className="card">
                                <div className="card-header">
                                    Opções
                                </div>
                                <div className="card-body">
                                    <Switcher onChange={this.onChange} colunas={colunas} />
                                </div>
                            </div>

                            <Agregador colunas={colunas} colunasSelecionadas={colunasSelecionadas} url={url} />

                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}